import type { UrlType } from '~~/common/stores/urlResource';
import { removeLocaleFromUrl } from '../utils/urlTransformation';

const routePageTypeMap = {
  '': 'home_page',
  '/shop': 'ecom_home_page',
  '/faq': 'faq_page',
  '/gyik': 'faq_page',
  '/food-delivery-map': 'food_delivery_map_page',
  '/kiszallitasi-teruleteink': 'food_delivery_map_page',
  '/payment-redirect': 'payment_redirect_page',
  '/unsubscribe': 'unsubscribe_page',
  '/hirlevel-leiratkozas': 'unsubscribe_page',
  '/forgotten-password': 'forgotten_password_page',
  '/login/Salesforce': 'salesforce_login_page',
  '/otp/back': 'payment_redirect_page',
  '/shop/basket': 'cart_page',
  '/shop/kosar': 'cart_page',
  '/shop/compare': 'compare_page',
  '/shop/termek-osszehasonlitas': 'compare_page',
  '/simple/back': 'payment_redirect_page',
  '/simple/gift/back': 'gift_card_order_payment_redirect_page',
  '/test/recon': 'recon_test_page',
  '/shop/profile/billing-addresses': 'profile_billing_addresses_page',
  '/shop/profilom/billing-addresses': 'profile_billing_addresses_page',
  '/shop/profile/data': 'profile_data_page',
  '/shop/profilom/data': 'profile_data_page',
  '/shop/profile/delivery-addresses': 'profile_delivery_addresses_page',
  '/shop/profilom/delivery-addresses': 'profile_delivery_addresses_page',
  '/shop/profile/mailing-addresses': 'profile_mailing_addresses_page',
  '/shop/profilom/mailing-addresses': 'profile_mailing_addresses_page',
  '/shop/profile/loyalty-card': 'loyalty_card_page',
  '/shop/profilom/bizalomkartyam': 'loyalty_card_page',
  '/shop/profile/loyalty-program': 'loyalty_program_page',
  '/shop/profilom/bizalomprogram': 'loyalty_program_page',
  '/shop/profile/loyalty-card/stickers': 'loyalty_stickers_page',
  '/shop/profilom/bizalomkartyam/matricaim': 'loyalty_stickers_page',
  '/shop/profile/loyalty-card/coupons': 'loyalty_coupons_page',
  '/shop/profilom/bizalomkartyam/kuponjaim': 'loyalty_coupons_page',
  '/shop/profile/loyalty-card/transactions': 'loyalty_transactions_page',
  '/shop/profilom/bizalomkartyam/korabbi-vasarlasaim': 'loyalty_transactions_page',
  '/shop/profile/loyalty-card/partner-program': 'loyalty_partner_program_page',
  '/shop/profilom/bizalomkartyam/partner-program': 'loyalty_partner_program_page',
  '/shop/profile/manage': 'profile_manage_page',
  '/shop/profilom/manage': 'profile_manage_page',
  '/shop/profile/order-again': 'order_again_page',
  'shop/profilom/gyakori-termekek': 'order_again_page',
  '/shop/profile/orders': 'orders_page',
  '/shop/profilom/korabbi-rendeleseim': 'orders_page',
  '/shop/profile/saved-baskets': 'saved_baskets_page',
  'shop/profilom/bevasarlo-listaim': 'saved_baskets_page',
  '/admin/cms/content_preview': 'cms_content_preview_page',
  '/shop/checkout': 'checkout_page',
  '/shop/list': 'shortlist_page',
  '/shop/loyalty-offers': 'loyalty_offers_page',
  '/shop/bizalomkartyas-ajanlatok': 'loyalty_offers_page',
  '/activate_registration': 'activate_registration_page',
  '/content': 'cms_content_page',
  '/password_change': 'password_change_page',
  '/product-list': 'category_page',
  '/product': 'item_page',
  '/user_email_update': 'user_email_update_page',
  '/catalog': 'catalog_page',
  '/katalogusok': 'catalog_page',
  '/csr': 'csr_page',
  '/inspirations': 'inspiration_page',
  '/inspiraciok': 'inspiration_page',
  '/news': 'news_page',
  '/hirek': 'news_page',
  '/press': 'press_release_page',
  '/sajtokozlemenyek': 'press_release_page',
  '/prize-game': 'prize_game_page',
  '/nyeremenyjatekok': 'prize_game_page',
};

export function calculatePageType (originalUrl: string, urlResourceStoreData?: UrlType) {
  let url: string | undefined = removeLocaleFromUrl(originalUrl) // no locale
    .split(/(#|\?)/, 1)?.[0]! // no fragment and no query
    .replace(/\/$/, '') // no trailing slash
  ;

  // remove last part and check again
  if (!routePageTypeMap[url as keyof typeof routePageTypeMap] && !urlResourceStoreData?.resourceType) {
    const urlParts = url.split('/');
    urlParts.pop();
    url = urlParts.join('/').replace(/\/$/, '') || undefined;
  }

  let pageType: string = routePageTypeMap[url as keyof typeof routePageTypeMap];
  if (!pageType && urlResourceStoreData?.resourceType) {
    switch (urlResourceStoreData.resourceType.toLowerCase()) {
      case 'product':
        pageType = 'item_page';
        break;
      case 'search':
        pageType = 'search_page';
        break;
      case 'category':
        pageType = 'category_page';
        break;
      case 'boutique':
        pageType = 'category_page';
        break;
      case 'cms_content':
        pageType = 'cms_content_page';
        break;
      default:
        pageType = 'fallback_page';
        break;
    }
  }
  if (!pageType) {
    pageType = 'fallback_page';
  }
  return pageType;
}
